<template>
  <div>
    <span class="text-sm uppercase text-gray-500 tracking-wider leading-4">
      Element Name
    </span>
    <div class="rounded-md shadow-sm">
      <input
        v-model="element.name"
        class="form-input block w-full transition duration-150 ease-in-out
        sm:text-sm sm:leading-5 text-gray-500"
        spellcheck="false"
        value=""
      />
    </div>
  </div>
</template>

<script>
// import Component from "../component_location"

export default {
  components: {},

  // props: ['element'],
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
    };
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style></style>
